module.exports = __webpack_public_path__ + "static/fonts/Oswald-MediumItalic.dc7a510.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-MediumItalic.ttf
// module id = 87lG
// module chunks = 1